import React from "react";

import {
  Heading,
  Box,
  Flex,
  Input,
  InputGroup,
  InputLeftElement,
  Button,
  Text,
  useColorModeValue,
  //
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
} from "@chakra-ui/react";

import MailViewed from "./MailViewed";

const Filters = () => {
  return (
    <Flex bg={"transparent"} alignItems={"center"} pb={"10px"}>
      <Text mr={3}>Filters</Text>
      {/* Filters List */}
      <Flex>
        <MailViewed />
      </Flex>
    </Flex>
  );
};

export default Filters;
